import HTTP from '@/utils/http'

class ClasscoreModel extends HTTP {
  /**
   * @description 查看个人中心赛季末评语
   * @see https://yapi.dayuan1997.com/project/23/interface/api/8586
   */
  getUserTermView(params) {
    return this.get({
      url: '/classcore/comment/my',
      // url: `/classcore/term/comment/user/view`,
      params,
    })
  }

  /**
   * @description 获取赛季末年份列表
   * @see http://yapi.dayuan1997.com/project/23/interface/api/6231
   */
  getUserTermListYear() {
    return this.get({
      url: `/classcore/comment/year`,
    })
  }

  /**
   * 获取队长信息
   * @see https://yapi.dayuan1997.com/project/23/interface/api/8086
   */
  getExpertInfo() {
    return this.get({
      url: '/classcore/expert/info',
    })
  }

  /**
   * 获取钻石
   */
  getJewel() {
    return this.get({
      url: '/classcore/award/jewel ',
    })
  }

  /**
   * 获取奖杯/勋章/令牌
   */
  getAward(params) {
    return this.get({
      url: '/classcore/award/info',
      params,
    })
  }

  /**
   * 赛季-用户是否需要确认地址-c端
   */
  needAddressConfirm() {
    return this.get({
      url: '/classcore/schoolcalendar/user/address/confirm',
    })
  }

  /**
   * 赛季-地址更新-c端
   */
  updateAddress(data) {
    return this.post({
      url: '/classcore/schoolcalendar/user/address/update',
      data,
    })
  }

  /**
   * 获取学员信息
   */
  getAggrUserInfo(userId) {
    return this.get({
      url: '/classcore/aggr/user/info',
      params: {
        userId,
      },
    })
  }
}

export default ClasscoreModel
